<template>
  <div>
    <div v-if="!cancelPolicy.cancelFree && cancelIsExpired" class="mt-4 mb-2 is-size-6 notification is-warning">
      <b>PLEASE NOTE:</b> The cancellation deadline for this reservation has already passed. If you cancel now, you may
      be charged a cancellation penalty <span v-if="cancelFee">of ${{ cancelFee }} </span>by the hotel. By cancelling
      this reservation, you acknowledge this fee.
    </div>

    <div v-else-if="!cancelPolicy.cancelFree" class="mt-4 mb-2 is-size-6 notification is-warning" >
      <b>PLEASE NOTE:</b> This reservation may be non-refundable or subject to fees or penalties by the hotel. Please
      review any written cancelation details before proceeding.
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cancelPolicy: {
      type: Object,
      required: true,
    },
  },
  computed: {
    cancelFee() {
      return this.cancelPolicy.cancelFee;
    },
    cancelIsExpired() {
      return this.cancelPolicy.isExpired;
    },
    cancelNights() {
      return this.cancelPolicy.cancelNights;
    },
    cancelDate() {
      return this.cancelPolicy.cancelDate;
    },
    cancelFree() {
      return this.cancelPolicy.cancelFree;
    },
  },
};
</script>

<style></style>
